<template>
	<div>
		<InsertTabs :tab="tab" :hasFb="hasFb" @checkInsertTab="checkInsertTab"></InsertTabs>
		
		<router-view :type="type" :is="tab" :hasFb="hasFb" :formData="formData" :checkList='checkList' :mobile="mobile"  @checkInsertTab="checkInsertTab"></router-view>
	</div>
</template>

<script>
	const InsertTabs = () => import('./InsertTabs');
	// const Personal = () => import('./Personal');
	const InsertQuestions = () => import('./InsertQuestions');
	const InsertFb = () => import('./InsertFb');
	const InsertBodily = () => import('./InsertBodily');
	const InsertBiochemical = () => import('./InsertBiochemical');
	
	export default{
		name: 'insertUpdataTemplate',
		data() {
			return {
				tab: 'InsertQuestions' ,//默认从个人信息开始填写
				
			}
		},
		components: {
			InsertTabs,
			// Personal,
			InsertQuestions,
			InsertFb,
			InsertBodily,
			InsertBiochemical
		},
		props: [ 'type', 'formData', 'mobile', 'checkList', 'hasFb' ],
		methods: {
			//切换tab 参数 tab组件名
			checkInsertTab(tab) {
				this.tab = tab;
			}
		}
	}
</script>

<style>
</style>
